import { z } from 'zod';

/**
 * Listados de documentos clínicos FIRMADOS (consentimiento, registro de
 * anestesia, hoja de gasto). Vista transversal de solo lectura para que el
 * personal consulte todos los documentos de un tipo, con filtros.
 */

export const ClinicalDocKindSchema = z.enum(['consent', 'anesthesia', 'expense']);
export type ClinicalDocKind = z.infer<typeof ClinicalDocKindSchema>;

/** Item común a los tres tipos de documento. */
export const ClinicalDocListItemSchema = z.object({
  id: z.string(),
  procedimientoId: z.string(),
  procedureTipo: z.string(),
  procedureFecha: z.string(),
  pacienteNombre: z.string(),
  pacienteDocumento: z.string(),
  /** Quién firmó el documento (médico / anestesiólogo / enfermera). */
  firmantePor: z.string(),
  firmadoEn: z.string(),
});
export type ClinicalDocListItem = z.infer<typeof ClinicalDocListItemSchema>;

export const ClinicalDocListSchema = z.object({
  items: z.array(ClinicalDocListItemSchema),
  total: z.number().int().nonnegative(),
});
export type ClinicalDocList = z.infer<typeof ClinicalDocListSchema>;

/** Filtros aceptados por el listado (todos opcionales salvo paginación). */
export const ClinicalDocsQuerySchema = z.object({
  q: z.string().trim().max(120).optional(),
  tipo: z.string().trim().max(300).optional(),
  desde: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  hasta: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export type ClinicalDocsQuery = z.infer<typeof ClinicalDocsQuerySchema>;
